import { render, staticRenderFns } from "./Operator.vue?vue&type=template&id=024f463a"
import script from "./Operator.vue?vue&type=script&lang=ts"
export * from "./Operator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports